import { HttpErrorResponse } from '@angular/common/http';

/** Only a server-issued MFA challenge is actionable; ordinary/identity 403s are not. */
export function isMfaStepUpChallenge(error: unknown): boolean {
  if (!(error instanceof HttpErrorResponse)) return false;
  const payload: unknown = error.error;
  return error.status === 403
    && error.headers.get('x-razor-mfa-step-up-required') === 'true'
    && typeof payload === 'object' && payload !== null
    && 'code' in payload && payload.code === 'MFA_STEP_UP_REQUIRED';
}
